/**
 * Audit-trail writes for location-session transitions — append-only INSERTs
 * into public.location_session_events. Every transition (select/relock/
 * switch) must call this; insert failures throw and are never swallowed —
 * the audit trail ("who is using this device right now") is a feature
 * requirement, not a nice-to-have (Task 2.1, docs/plans/2026-07-30-location-login.md).
 */

import { supabase } from '@/integrations/supabase/client';
import type { LocationSessionEventType, LocationSessionGroup, LocationSessionTeacher } from '../types';

export const locationSessionService = {
  async recordEvent(params: {
    event: LocationSessionEventType;
    locationCode: string;
    group: LocationSessionGroup | null;
    teacher: LocationSessionTeacher | null;
  }): Promise<void> {
    const { data: userData, error: userError } = await supabase.auth.getUser();
    if (userError) throw userError;
    const locationUserId = userData.user?.id;
    if (!locationUserId) {
      throw new Error('locationSessionService.recordEvent: no authenticated user');
    }

    const { error } = await supabase.from('location_session_events').insert({
      location_user_id: locationUserId,
      location_code: params.locationCode,
      group_id: params.group?.id ?? null,
      selected_staff_id: params.teacher?.staffId ?? null,
      event: params.event,
    });
    if (error) throw error;
  },
};
